
import React from 'react';
import styles from './FAQSection.module.css';

const FAQSection = () => {
  return (
    <div className={styles.faqSection}>
      <h2 className={styles.faqTitle}>Frequently Asked Questions</h2>
      <div className={styles.faqContainer}>
        <div className={styles.faqItem}>
          <button className={styles.faqButton} onClick={(e) => e.currentTarget.parentElement.classList.toggle(styles.active)}>
            What is Puntology?
            <span className={styles.arrow}>▼</span>
          </button>
          <div className={styles.faqContent}>
            <p>We are Australia's fastest growing sportsbetting community. We utilise AI to analyse statistics and data to provide our members with constantly winning bets.</p>
          </div>
        </div>
        <div className={styles.faqItem}>
          <button className={styles.faqButton} onClick={(e) => e.currentTarget.parentElement.classList.toggle(styles.active)}>
            How much money do I need to start?
            <span className={styles.arrow}>▼</span>
          </button>
          <div className={styles.faqContent}>
          <p>While there is no requirement on how much money you need, for maximum results we recommend $500+.</p>
          </div>
        </div>
        <div className={styles.faqItem}>
          <button className={styles.faqButton} onClick={(e) => e.currentTarget.parentElement.classList.toggle(styles.active)}>
            How old do I need to be?
            <span className={styles.arrow}>▼</span>
          </button>
          <div className={styles.faqContent}>
          <p>You must be the legal age requireed from your governing state. For Australia, it is 18+ nation wide.</p>
          </div>
        </div>
        <div className={styles.faqItem}>
          <button className={styles.faqButton} onClick={(e) => e.currentTarget.parentElement.classList.toggle(styles.active)}>
            Is it a lock-in membership?
            <span className={styles.arrow}>▼</span>
          </button>
          <div className={styles.faqContent}>
          <p>Nope! You cancel whenever you want and your membership will cancel at the end of your term, whether that be weekly or monthly.</p>
          </div>
        </div>
        <div className={styles.faqItem}>
          <button className={styles.faqButton} onClick={(e) => e.currentTarget.parentElement.classList.toggle(styles.active)}>
            How does it work?
            <span className={styles.arrow}>▼</span>
          </button>
          <div className={styles.faqContent}>
          <p>You simply join our services and copy exactly what we post. It's as simple as that!</p>
          </div>
        </div>
        <div className={styles.faqItem}>
          <button className={styles.faqButton} onClick={(e) => e.currentTarget.parentElement.classList.toggle(styles.active)}>
            I have zero knowledge on making money online, can I still join?
            <span className={styles.arrow}>▼</span>
          </button>
          <div className={styles.faqContent}>
          <p>Absolutely! Our group caters to both beginners and experts, we provide in-depth guides, and offer 1 on 1 support 24/7 to help you understand and learn the process.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQSection;
